(function () {
  function initHeader(header) {
    if (!header || header.dataset.bbriReady === 'true') return;
    header.dataset.bbriReady = 'true';

    var mobileQuery = window.matchMedia('(max-width: 1180px)');
    var menuButton = header.querySelector('[data-bbri-menu-toggle]');
    var nav = header.querySelector('[data-bbri-primary-nav]');
    var shop = header.querySelector('[data-bbri-shop]');
    var shopButton = header.querySelector('[data-bbri-shop-toggle]');
    var submenu = header.querySelector('[data-bbri-shop-submenu]');
    var hasShopMenu = Boolean(shop && shopButton && submenu);
    if (!menuButton || !nav) return;

    function setMenu(open) {
      var isMobile = mobileQuery.matches;
      var nextOpen = isMobile && open;
      header.classList.toggle('bbri-header--menu-open', nextOpen);
      menuButton.setAttribute('aria-expanded', String(nextOpen));
      menuButton.setAttribute('aria-label', nextOpen ? 'Close menu' : 'Open menu');
      nav.setAttribute('aria-hidden', String(isMobile && !nextOpen));
    }

    function setShop(open) {
      if (!hasShopMenu) return;
      shop.classList.toggle('bbri-header__shop--open', open);
      shopButton.setAttribute('aria-expanded', String(open));
      shopButton.setAttribute('aria-label', open ? 'Hide Shop menu' : 'Show Shop menu');
      submenu.setAttribute('aria-hidden', String(!open));
    }

    menuButton.addEventListener('click', function () {
      setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
    });

    if (hasShopMenu) {
      shopButton.addEventListener('click', function (event) {
        if (!mobileQuery.matches && event.detail > 0) {
          setShop(true);
        } else {
          setShop(shopButton.getAttribute('aria-expanded') !== 'true');
        }
      });

      shopButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setShop(shopButton.getAttribute('aria-expanded') !== 'true');
      });

      shop.addEventListener('pointerenter', function () {
        if (!mobileQuery.matches) setShop(true);
      });

      shop.addEventListener('pointerleave', function () {
        if (!mobileQuery.matches && !shop.contains(document.activeElement)) setShop(false);
      });

      shop.addEventListener('focusin', function (event) {
        if (event.target === shopButton && shopButton.getAttribute('aria-expanded') === 'false') return;
        setShop(true);
      });

      shop.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!shop.contains(document.activeElement)) setShop(false);
        }, 0);
      });
    }

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (hasShopMenu && shopButton.getAttribute('aria-expanded') === 'true') {
        setShop(false);
        shopButton.focus();
      } else if (menuButton.getAttribute('aria-expanded') === 'true') {
        setMenu(false);
        menuButton.focus();
      }
    });

    document.addEventListener('pointerdown', function (event) {
      if (!header.contains(event.target)) {
        if (hasShopMenu) setShop(false);
        setMenu(false);
      }
    });

    nav.addEventListener('click', function (event) {
      if (event.target.closest('a') && mobileQuery.matches) setMenu(false);
    });

    function syncBreakpoint() {
      setMenu(false);
      if (mobileQuery.matches) setShop(false);
      nav.setAttribute('aria-hidden', String(mobileQuery.matches));
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncBreakpoint);
    } else {
      mobileQuery.addListener(syncBreakpoint);
    }

    syncBreakpoint();
  }

  function getNewYorkDateKey(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return values.year + '-' + values.month + '-' + values.day;
  }

  function getTimeSortValue(value) {
    var match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i);
    if (!match) return Number.MAX_SAFE_INTEGER;

    var hour = Number(match[1]);
    var minute = Number(match[2]);
    var meridiem = match[3] ? match[3].toUpperCase() : '';

    if (minute > 59 || hour > 23 || (meridiem && (hour < 1 || hour > 12))) {
      return Number.MAX_SAFE_INTEGER;
    }

    if (meridiem === 'AM' && hour === 12) hour = 0;
    if (meridiem === 'PM' && hour !== 12) hour += 12;

    return hour * 60 + minute;
  }

  function initToday(today) {
    if (!today || today.dataset.bbriTodayReady === 'true') return;
    today.dataset.bbriTodayReady = 'true';

    var now = new Date();
    var dateKey;
    var dateElement = today.querySelector('[data-bbri-today-date]');
    var eventList = today.querySelector('[data-bbri-today-events]');
    var emptyState = today.querySelector('[data-bbri-today-empty]');

    try {
      dateKey = getNewYorkDateKey(now);
      if (dateElement) {
        dateElement.textContent = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        }).format(now).toUpperCase();
      }
    } catch (error) {
      // Keep the store-timezone date and safe empty state when Intl is unavailable.
      return;
    }

    if (!eventList || !emptyState) return;

    var events = Array.prototype.slice.call(eventList.querySelectorAll('[data-bbri-today-event]'));
    events.forEach(function (eventCard) {
      eventCard.hidden = true;
    });

    var todaysEvents = events
      .filter(function (eventCard) {
        return eventCard.dataset.eventDate === dateKey;
      })
      .sort(function (first, second) {
        return getTimeSortValue(first.dataset.eventStart) - getTimeSortValue(second.dataset.eventStart);
      })
      .slice(0, 4);

    todaysEvents.forEach(function (eventCard) {
      eventCard.hidden = false;
      eventList.appendChild(eventCard);
    });

    var hasEvents = todaysEvents.length > 0;
    eventList.hidden = !hasEvents;
    emptyState.hidden = hasEvents;
    today.classList.toggle('bbri-today--has-events', hasEvents);
  }

  function sendAnalyticsEvent(name, payload) {
    var allowedEvents = {
      calendar_view: true,
      event_view: true,
      event_source_click: true,
      today_on_block_click: true,
      weekend_guide_click: true,
      email_signup: true,
      nightlife_guide_click: true,
      social_profile_click: true,
      submit_event: true
    };

    if (!allowedEvents[name]) return;

    var safePayload = {
      page_path: window.location.pathname
    };
    var allowedKeys = ['placement', 'platform', 'event_title', 'venue', 'source_domain', 'form_location'];

    allowedKeys.forEach(function (key) {
      if (payload && payload[key]) safePayload[key] = String(payload[key]).slice(0, 150);
    });

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, safePayload);
    }
  }

  function initTracking(root) {
    var scope = root || document;

    if (scope.querySelector('[data-bbri-calendar-page]') && document.documentElement.dataset.bbriCalendarView !== 'true') {
      document.documentElement.dataset.bbriCalendarView = 'true';
      sendAnalyticsEvent('calendar_view');
    }

    if (scope.querySelector('[data-bbri-event-page]') && document.documentElement.dataset.bbriEventView !== 'true') {
      document.documentElement.dataset.bbriEventView = 'true';
      sendAnalyticsEvent('event_view');
    }

    scope.querySelectorAll('[data-bbri-track-form]').forEach(function (form) {
      if (!form.querySelector('.bbri-form-success') || form.dataset.bbriSuccessTracked === 'true') return;
      form.dataset.bbriSuccessTracked = 'true';
      sendAnalyticsEvent(form.dataset.bbriTrackForm, {
        form_location: form.dataset.bbriFormLocation
      });
    });

    if (document.documentElement.dataset.bbriClickTracking === 'true') return;
    document.documentElement.dataset.bbriClickTracking = 'true';

    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-bbri-track]');
      if (!target) return;

      sendAnalyticsEvent(target.dataset.bbriTrack, {
        placement: target.dataset.bbriPlacement,
        platform: target.dataset.bbriPlatform,
        event_title: target.dataset.bbriEventTitle,
        venue: target.dataset.bbriVenue,
        source_domain: target.dataset.bbriSourceDomain
      });
    });
  }

  function cleanUtilityOutput() {
    if (window.location.pathname !== '/pages/buy-again') return;

    document.querySelectorAll('main *').forEach(function (element) {
      if (element.children.length === 0 && element.textContent.trim() === 'Debug') {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bbri-header]').forEach(initHeader);
    (root || document).querySelectorAll('.bbri-today').forEach(initToday);
    initTracking(root || document);
    cleanUtilityOutput();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
